import { mapState } from 'vuex';
import numeral from 'numeral';
import prettyMs from 'pretty-ms';
import store from '@/store';
import vueapi from '@/_api/index.js'
import config from '@/helpers/config';
import { shorten, etherscanLink } from '@/helpers/utils';

// @ts-ignore
const modules = Object.entries(store.state).map(module => module[0]);
import {mapActions} from 'vuex'

let $store = (store as any)
import bus from '@/bus.js'

export default {
  data() {
    return {
      config
    };
  },
  computed: {
    ...mapState(modules)
  },
  methods: {
    ...mapActions([
      'getETHBalance',
      'getUSDTBalance',
      'getAXISBalance',
      'getCakeBalance',
      'accountSign',
      'getCurrentBlockNumber',
      'getNFTItemURL',
      'verifyNFTOwner',
      'getWBNBBalance',
    ]),

    async uniGetCurrentBlockNum(){
      let v = this
      let res  = await v.getCurrentBlockNumber()
      console.log('current block num - '+res)

      $store.commit('setWeb3Data',{
        current_block_num: res
      })
      return res
    },

    uniCheckLikeStatus(item){
      let v = this
      let mark = false

      let liked = $store.state.user.data_list_liked.find(function(i){
        if (
          i.nft_id === item.nft_id && 
          i.nft_address === item.nft_address &&
          i.owner === item.owner
        ){
          return true
        }else{
          return false
        }
      })

      if(liked){
        mark = true
      }
      return mark
    },

    async uniSetLikeStatus(item,mark){

      if(!$store.state.user.local_user.address){
        bus.headervue.mark_sign_ui_call += 1
        return
      }

      // 
      let api_str = ''
      if(mark){
        api_str = 'action_like'
      }else{
        api_str = 'action_unlike'
      }

      // 
      let address_user = $store.state.user.local_user.address
      let sig = await this.accountSign(address_user)

      let res = await vueapi(api_str,{
        address: address_user,
        sign: sig,
        nft_address: item.nft_address,
        nft_id: item.nft_id,
        owner: item.owner,
      })

      console.log('uniSetLikeStatus res:',res)
      this.uniListMyLikedItems()

      if(res.code == 0){
        return mark
      }
    },

    async uniListMyLikedItems(){

      let address_user = $store.state.user.local_user.address
      
      if(!address_user){
        $store.commit('setUserKey',{
          data_list_liked: []
        })
        return
      }
      console.log('uniListMyLikedItems',address_user)
      let res = await vueapi('list_asset_my_like',{
        address: address_user,
        category: 'all',
      })

      if(res && res.data){
        
        // store list
        $store.commit('setUserKey',{
          data_list_liked: res.data
        })

        return res.data
      }else{
        console.log('Err.on.liked')
        return []
      }
    },

    // 
    uniCleanUserLogin(){
      console.log('uniCheckUserLogin clean')
      $store.commit('setLocalUserKey',{
        id: '',
        address: '',
        email: '',
        username: '',
        imageURL: '',
      })
      $store.commit('setUserKey',{
        data_list_liked: [],
      })
    },
    async uniCheckUserLogin(){
      let address_my = $store.state.web3.account
      console.log('uniCheckUserLogin')

      if(address_my){
        let res = await vueapi('user_info',{address: address_my})
        if(res.data && res.data.id){
          
          $store.commit('setLocalUserKey',{
            id: res.data.id,
            address: res.data.address,
            email: res.data.email,
            username: res.data.username,
            imageURL: res.data.imageURL,
            bio: res.data.bio || '',
          })

          return res.data
        }else{
          this.uniCleanUserLogin()
          return false
        }
      }
      
      else{
        this.uniCleanUserLogin()
        return false
      }
    },

    // uni fetch item info
    async uniFetchItemInfo(item:any){
      console.log('##########')
      let v = this

      let res:any
      let origin_url = '' + item.url + item.nft_id

      // 匹配特定nft_address，通过 web3js 中 getNFTItemURL() 专用方法拿数据的
      let arr_address = [
        // 说明：这里可以继续加其他合约地址
        '0x081C4b1018dE72435F85c942b4045bee578AEf05',
      ].map(item => item.toLowerCase())

      if(arr_address.indexOf(item.nft_address.toLowerCase()) >= 0){

        res = await v.getNFTItemURL({
          nft_address: item.nft_address,
          nft_id: item.nft_id,
        })
        
        origin_url = res
      }
      
      res = await fetch(origin_url)


      res = await res.json()

      // fix me ...
      // res = await res.text()
      // res = res.replace(/[\r\n]/g, "").replace(/(?<!(:|,|{))"(?!(:|,|}))/g, `'`)
      // res = JSON.parse(res)


      
      // reset数据
      let re_res = v.uniRedataItemDataToMemeType(res,origin_url)
      

      return re_res
    },

    // uni method for multi data origin
    uniRedataItemDataToMemeType(data,origin_url){

      // keys ui needed
      // default meme keys
      let new_data = {
        name: data.name || '',
        image: data.image || '',
        description: data.description || '',
        attributes: data.attributes || [],
      }

      // err res from input data
      if(typeof data !== 'object'){
        console.log('Err.in.redataItem')
        return new_data
      }
      
      // reset dego keys
      if(origin_url.indexOf('api.dego.') >= 0){
        if(data.status == 10000){

          let d = data.result.data

          new_data.name = d.name
          new_data.image = d.big_image
          new_data.description = d.description
        }
      }

      // reset ipfs://
      for(let key in new_data){
        let val = new_data[key]
        if(val.indexOf('') === 0){
          new_data[key] = (new_data[key]).replace('ipfs://ipfs/','https://ipfs.io/ipfs/')
        }
      }

      return new_data
    },

    async uniCalcItemBuySellBtnStatus(m_item,thatvue){
      let v = this

      let meta_item = JSON.parse(JSON.stringify(m_item))

      let address_my = $store.state.web3.account

      // no order
      // console.log('meta_item',meta_item)
      // console.log('111',meta_item.sell_info)
      // console.log('222',meta_item.sell_info.address)
      // console.log('333',meta_item.sell_info.id)
      if( (!meta_item.sell_info.address || !meta_item.sell_info.id) ){
        console.log('========================= no order')
        
        let d_owner = meta_item.owner_info.address || ''
        if( d_owner.toLowerCase() === address_my.toLowerCase() ){
          let is_owner = await v.verifyNFTOwner({
            address: $store.state.web3.account,
            NTFS_TOKEN_ADDRESS: meta_item.nft_address,
            NFT_ID: meta_item.nft_id,
            type: meta_item.type,
          })


          
          
          console.log('is_owner',is_owner)
          if(is_owner){
            thatvue.status_show_btn_cancel = false
            thatvue.status_show_btn_sell = true
            thatvue.status_show_btn_buy = false
          }
          else{
            thatvue.status_show_btn_cancel = false
            thatvue.status_show_btn_sell = false
            thatvue.status_show_btn_buy = false
          }
        }
        else{
          thatvue.status_show_btn_cancel = false
          thatvue.status_show_btn_sell = false
          thatvue.status_show_btn_buy = false
        }
      }
      // be order
      else{
        console.log('========================= be order')
        let address_my = ($store.state.web3.account || '').toLowerCase()
        let address_owner = (meta_item.sell_info.address ||  '').toLowerCase()

        if(address_my === address_owner){
          thatvue.status_show_btn_cancel = true
          thatvue.status_show_btn_buy = false
          thatvue.status_show_btn_sell = false
        }else{
          thatvue.status_show_btn_cancel = false
          thatvue.status_show_btn_buy = true
          thatvue.status_show_btn_sell = false
        }
      }
    },

    // uni method for user balance
    async uniGetWalletBalance(){
      // console.log(']]]]]]]]]]]]]]]uniGetWalletBalance')
      let v = this
      let address_my = $store.state.web3.account

      
      if(!address_my){
        $store.state.web3.account_wallet.forEach(function(item){
          $store.commit('setWeb3AccountWalletItem',{
            id: item.id,
            num: 0
          })
        })
        return
      }


      let b_eth = await v.getETHBalance(address_my)
      $store.commit('setWeb3AccountWalletItem',{
        id: 'eth',
        num: b_eth
      })

      let b_weth = await v.getWBNBBalance(address_my)
      $store.commit('setWeb3AccountWalletItem', {
        id: 'weth',
        num: b_weth
      })

      let b_usdt = await v.getUSDTBalance(address_my)
      $store.commit('setWeb3AccountWalletItem',{
        id: 'usdt',
        num: b_usdt
      })

      let b_axis = await v.getAXISBalance(address_my)
      $store.commit('setWeb3AccountWalletItem',{
        id: 'axis',
        num: b_axis
      })

      let b_cake = await v.getCakeBalance(address_my)
      $store.commit('setWeb3AccountWalletItem', {
        id: 'cake',
        num: b_cake
      })

    },

    _ms(number) {
      const diff = number * 1e3 - new Date().getTime();
      return prettyMs(diff);
    },
    _numeral(number, format = '(0.[00]a)') {
      return numeral(number).format(format);
    },
    _shorten(str: string, key: string): string {
      let limit;
      if (key === 'symbol') limit = 6;
      if (key === 'name') limit = 64;
      if (key === 'choice') limit = 12;
      if (limit)
        return str.length > limit ? `${str.slice(0, limit).trim()}...` : str;
      return shorten(str);
    },
    _etherscanLink(str: string, type: string): string {
      return etherscanLink(str, type);
    }
  }
};
